import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';

import { ILogonDocument } from 'app/services/api5-service/api.interface';

import { getDynamicFormContext } from 'common/dynamic-form-context/get-dynamic-form-context';
import {
  IFormButtonClickEvent,
  IFormModel,
} from 'common/dynamic-form/dynamic-form.interface';
import { DynamicFormContext } from 'common/dynamic-form/model';
import { TemplateConfig } from 'common/dynamic-form/types/template/model';

import { CopyrightData } from './copyright/model';
import { DocumentsData } from './documents/model';
import { RegisterData } from './register/model';
import { SocialData } from './social/model';

@Component({
  selector: 'isp-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./scss/login-form.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginFormComponent implements OnChanges {
  @Input() doc: ILogonDocument;

  @Input() socialData: SocialData | null = null;

  @Input() registerData: RegisterData | null = null;

  @Input() documentsData: DocumentsData | null = null;

  @Input() copyrightData: CopyrightData | null = null;

  @Input() templateConfigs: TemplateConfig[] = [];

  @Output() readonly buttonClick = new EventEmitter<IFormButtonClickEvent>();

  @Output() readonly changeModel = new EventEmitter<IFormModel>();

  context: DynamicFormContext;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.doc) {
      const doc = changes.doc.currentValue;

      this.context = getDynamicFormContext(doc);
    }
  }
}
